
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/iogames-widget",
      function () {
        return require("private-next-pages/developer/iogames-widget/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/iogames-widget"])
      });
    }
  